<template>
    <div class="send-sms">

        <mu-flex justify-content="start" align-items="center" class="shortcut shortcut-sms">
            <div class="icon">
                <img src="/svg/dashboard/sms.svg"/>
            </div>
            <div class="content">
                <h3>Envio de Mensagens</h3>
                <div class="links">
                    <a href="javascript:;" @click="send.open = true">Simples</a>
                    <router-link :to="{ name: 'app.services.sms.create' }">Campanha</router-link><br>
                    <router-link :to="{ name: 'app.services.sms.create.variables' }">Campanha com Variáveis</router-link>
                </div>
            </div>
        </mu-flex>

        <mu-dialog title="Envio Simples" width="460" :open.sync="send.open">

            <mu-paper class="alert-balance" :z-depth="1" v-if="getBalanceByService == 0 && isCompanyPrepaid && id_service">
                <mu-flex class="alert-content">
                    <div class="icon-alert">
                        <font-awesome-icon icon="exclamation-triangle" size="3x" :style="{ color: '#ffbc33' }" />
                    </div>
                    <div class="text-alert">
                        <span>Atenção</span>
                        <p>Você selecionou o tipo de mensagem <b>"{{ getServiceName(id_service) }}"</b> e você não possui créditos para esse serviço.</p>
                    </div>
                </mu-flex>
            </mu-paper>

            <!-- Se algum número não foi validado -->
            <div v-if="!validate.valid">
                <mu-text-field full-width label="Título do envio" v-model="title" class="mb-0" required></mu-text-field>
                <mu-select label="Serviço" v-model="id_service" full-width class="mb-0" @change="messageSlug">
                    <mu-option v-for="(item, key) in options.services" :key="key" :label="item.services.name" :value="item.services.id"></mu-option>
                </mu-select>

                <mu-text-field full-width label="Contatos Ex.: 47991911234,47991915678" v-model="string_contact" class="mb-0"></mu-text-field>
                <div class="phones-invalid" v-if="validate && validate.result && validate.result.correts && validate.result.correts.totalvalid == 0">
                    Nenhum número digitado no contato é válido.
                </div>
                <!-- <mu-text-field multi-line full-width label="Mensagem" v-model="message" :help-text="`Você já digitou ${message.length} caracteres`" :rows="4" :rows-max="4" class="mb-0 textarea" v-on:keyup="messageSlug" @change="messageSlug"></mu-text-field> -->

                <!-- CAMPOS DE MENSAGEM PADRÃO -->
                <!-- Escolher entre uma nova mensagem ou mensagem padrão -->
                <div class="radio-box">
                    <mu-radio style="margin-right: 15px;" v-model="selected_type" value="new_message" label="Nova Mensagem" @click="formMessageSlug"></mu-radio>
                    <mu-radio v-model="selected_type" value="default_message" label="Mensagem Padrão" @click="formMessageSlug"></mu-radio>
                </div>

                <div v-if="selected_type == 'default_message'">

                    <!-- Selecionar a mensagem padrão -->
                    <mu-select label="Mensagem Padrão *" v-model="default_message" full-width @change="defaultMessage">
                        <mu-option v-for="(option, key) in options.default_message" :key="key" :label="option.description" :value="option.id"></mu-option>
                    </mu-select>

                    <!-- Mensagem escolhida  -->
                    <mu-text-field multi-line full-width :rows="4" placeholder="Mensagem Escolhida" :rows-max="4" disabled v-model="default_message_description"></mu-text-field>
                </div>

                <!-- Campo para digitar a nova mensagem -->
                <div v-if="selected_type == 'new_message'">
                    <mu-text-field multi-line full-width placeholder="Mensagem" :rows="4" :rows-max="4" v-model="message" :help-text="`Você já digitou ${countChars(message)} caracteres`" v-on:keyup="formMessageSlug" @change="formMessageSlug"></mu-text-field>
                </div>

                <div v-if="countChars(selected_type == 'new_message' ? message : default_message_description) > 160" class="alert-limit-characters">
                    <font-awesome-icon icon="exclamation-triangle" /> A mensagem contém mais de 160 caracteres. {{ countCredits(selected_type === 'new_message' ? message : default_message_description) }} créditos serão consumidos para cada contato.
                </div>

                <!-- FIM CAMPOS DE MENSAGEM PADRÃO -->

                <br>
                <mu-button v-if="!validate.valid" color="secondary" round @click="validateContacts()" :disabled="!title || !id_service || !string_contact || (!message && !default_message_description) || (getBalanceByService == 0 && isCompanyPrepaid && id_service)">Validar</mu-button>
                <mu-button round @click="closeModal()">Cancelar</mu-button>
            </div>

            <!-- Para os números validados mesmo que tenha alguns números inválidos -->
            <div class="send-sms" v-if="validate.valid">
                <h3>Os números foram validados</h3>
                <p>Agora você precisa enviar a mensagem</p>
                <mu-row gutter>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <div v-if="validate && validate.result && validate.result.correts" class="result-numbers corrects">
                            <font-awesome-icon icon="check" size="2x" />
                            <br>
                            {{ validate.result.correts.totalvalid || 0 }} número(s) válido(s) <br>
                            {{ validate.result.correts.numvalid }}
                        </div>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <div v-if="validate && validate.result && validate.result.incorrets" class="result-numbers incorrects">
                            <font-awesome-icon icon="ban" size="2x" />
                            <br>
                            {{ validate.result.incorrets.totalinvalid || 0 }} número(s) inválido(s) <br>
                            {{ validate.result.incorrets.numinvalid }}
                        </div>
                    </mu-col>
                </mu-row>
                <mu-button color="primary" round @click="sendMessage()" :disabled="!title || !id_service || !string_contact || (!message && !default_message_description)">Enviar</mu-button>
                <mu-button round @click="validate.valid = false">Voltar</mu-button>
            </div>

        </mu-dialog>

    </div>
</template>

<script>
    import ServicesServices from '@/services/settings/channels-clients'
    import SmsServices from '@/services/dashboards/sms'
    import ContactsServices from '@/services/contacts/contacts'
    import MessageDefaultServices from '@/services/settings/message-default'
    import BalanceServices from '@/services/dashboards/balance'

    export default {
        name: 'sms-shooting',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    services: [],
                    default_message: []
                },
                validate: {
                    valid: false,
                    result: {}
                },
                send: {
                    open: false
                },
                title: '',
                id_service: null,
                string_contact: '',
                message: '',
                selected_type: 'new_message',
                default_message: '',
                default_message_description: '',
                form: {},
                balances: {
                    loading: false,
                    list: []
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {
            /**
             * Encontrando o serviço selecionado e retornando o saldo dele
             */
            getBalanceByService () {
                let find = this.balances.list.find((item) => {
                    return item.service_id === this.id_service
                })
                return find ? find.balance : 0
            },

            /**
             * Trás os dados da empresa gravadas no state
             */
            isCompanyPrepaid () {
                return this.$store.state.company.signatureType === 'P' || this.$store.state.company.signatureType === 'T'
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            await this.loadServices()
            await this.loadBalances()
            await this.loadMessageDefault()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            /**
             * Carrega o saldo da empresa
             */
            async loadBalances () {
                try {
                    let result = await BalanceServices.balances()
                    if (result && result.status) {
                        this.balances.list = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o saldo da empresa.')
                }
            },

            /**
             * Método responsável por carregar os serviços disponíveis para a empresa logada
             */
            async loadServices () {
                try {
                    let result = await ServicesServices.findAll()

                    if (result && result.status) {
                        this.options.services = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os serviços.')
                }
            },

            /**
             * Método que faz a validação dos contatos
             */
            async validateContacts () {
                try {
                    this.$eventHub.$emit('loading', true, 'Validando contatos (telefones).')

                    let result = await ContactsServices.validate({
                        numbers: this.string_contact
                    })

                    if (result) {
                        this.validate.result = result
                        this.validate.result.correts.numvalid = this.validate.result.correts.numvalid.replace(/,/g, ', ')
                        this.validate.result.incorrets.numinvalid = this.validate.result.incorrets.numinvalid.replace(/,/g, ', ')
                        if (result.correts.totalvalid > 0) {
                            this.string_contact = result.correts.numvalid
                            this.validate.valid = true
                        }
                        return
                    }

                    throw Error()
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível validar os contatos.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Método que faz o envio da mensagem depois de validado
             */
            async sendMessage () {
                try {
                    this.$eventHub.$emit('loading', true, 'Enviando mensagem.')

                    let informContacts = []
                    if (this.string_contact.includes(',')) {
                        informContacts = this.string_contact.split(',')
                    } else {
                        informContacts[0] = this.string_contact
                    }

                    let contacts = JSON.stringify({
                        groups: [],
                        contacts: [],
                        inform_contacts: informContacts
                    })

                    // `Envio Rápido SMS - por ${this.$store.state.user.firstName}`
                    this.form = {
                        title: this.title,
                        message: '',
                        contacts: contacts,
                        service_Id: this.id_service,
                        channelCode: this.getChannelCode(this.id_service),
                        totalContacts: informContacts.length
                    }

                    if (this.selected_type !== 'new_message') {
                        this.form.message = this.default_message_description
                    } else {
                        this.form.message = this.message
                    }

                    let result = await SmsServices.store(this.form)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.form = {}
                        this.closeModal()
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível enviar a mensagem.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Método responsável por fechar o modal
             */
            closeModal () {
                this.send.open = false
                this.validate.valid = false
            },

            /**
             * Retorna o nome do canal encontrado dentre os da lista
             */
            getChannelCode (serviceId) {
                let channel = this.options.services.find((item) => {
                    return item.services.id === serviceId
                })
                if (channel) {
                    return channel.ch1
                }
                return ''
            },

            /**
             * Encontrando o nome do serviço
             */
            getServiceName (serviceId) {
                if (serviceId === null) {
                    return 0
                }
                let find = this.options.services.find((item) => {
                    console.log(item.services.id, serviceId)
                    return item.services.id === serviceId
                })
                console.log(find)
                return find ? find.services.name : ''
            },

            /**
             * Formata a mensagem removendo caracteres especiais, etc...
             */
            messageSlug () {
                if (this.id_service === 4) {
                    return
                }
                this.message = this.strSlug(this.message)
            },

            // MENSAGEM PADRÃO
            /**
             * Formata a mensagem removendo caracteres especiais, etc...
             */
            formMessageSlug () {
                if (this.id_service === 4) {
                    return
                }
                this.message = this.strSlug(this.message)
            },

            /**
             * Busca a mensagem padrão na lista para popular o textarea
             */
            async defaultMessage () {
                try {
                    let find = await this.options.default_message.find((item) => {
                        return item.id === this.default_message
                    })
                    if (this.selected_type === 'new_message') {
                        this.formMessageSlug()
                    }
                    if (!find) {
                        return
                    }
                    if (this.id_service === 4) {
                        this.default_message_description = find.message || ''
                    } else {
                        this.default_message_description = find.finalmessage || ''
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível encontrar a descrição da mensagme padrão.')
                }
            },

            /**
             * Carrega as mensagens padrões
             */
            async loadMessageDefault () {
                try {
                    let result = await MessageDefaultServices.findAll()
                    if (result && result.status) {
                        this.options.default_message = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar as mensagens padrão.')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .radio-box
        margin-bottom 15px

    .mu-button
        margin-right 5px

    .phones-invalid
        color $red
        margin-top -25px
        margin-bottom 15px

    .result-numbers
        text-align center
        margin 20px 0 40px 0
        &.incorrects
            color $red
        &.corrects
            color $green

    .textarea
        .mu-input
            margin 0 !important
            padding 0 !important

    .send-sms

        .alert-balance
            margin-bottom 30px
            &.on-step4
                margin-top 20px
            .alert-content
                padding 30px
                background #fffae3
                .icon-alert, .text-alert
                    display inline-block
                    vertical-align middle
                    align-itens center
                    svg
                        font-size 50px
                        color #ffbc33
                        display block
                    &.icon-alert
                        max-width 15%
                        margin-right 30px
                    &.text-alert
                        max-width 85%
                        span
                            font-weight bold
                            font-size 18px
                            color #000000
                        p
                            margin 0
                            font-size 12px

        .shortcut
            padding 15px
            overflow auto
            border-radius 5px
            background lighten($grey, 80%)
            border-radius 5px
            border 1px lighten($grey, 40%) dotted

            img
                width 85%

            div
                float left
                &.icon
                    width 25%
                &.content
                    width 75%

            &.shortcut-sms

                .content
                    color $primary
                    a
                        &:hover
                            text-decoration underline
                    h3
                        margin 0
                        font-size 20px
                        line-height 20px

        .links
            padding-top 12px
            a
                margin-right 6px
                margin-bottom 6px
                text-decoration none !important
                text-transform uppercase
                background $grey
                color #fff
                padding 4px 10px
                line-height 26px
                border-radius 15px
                font-size 11px
                &:hover
                    text-decoration none !important
                    background darken($grey, 10%)

    .alert-limit-characters
        padding 8px
        border-radius 4px
        font-size 11px
        background lighten($red, 80%)
        color darken($red, 10%)

</style>
